<template>
  <div class="cn-recaptcha">
    <ClientOnly>
      <VueRecaptcha
        @success="$emit('success', $event)"
        @expired="$emit('expired')"
        @error="$emit('error')"
      />
    </ClientOnly>
  </div>
</template>

<script setup lang="ts">
import { Checkbox as VueRecaptcha, useRecaptchaProvider } from 'vue-recaptcha';

defineEmits<{
  (e: 'success', token: string): void;
  (e: 'expired' | 'error'): void;
}>();

// Injects the reCAPTCHA script. `plugins/recaptcha.client.ts` provides its
// context on the client only, so calling this during SSR would throw
if (import.meta.client) useRecaptchaProvider();
</script>
